import React, { useEffect, useState } from "react";
import axios from "axios";
import { file_path } from "./environment";

function Select({ guide }) {

    function onPublicationSelected(event) {
        const publication_id = event.target.value;
        window.location.href = `/research/${publication_id}.html`;
    }

    const options = guide.years.sort((p1, p2) => p2 - p1).map((year) => {
        return <option value={`${guide.guideType} ${year}`} key={year}>{year}</option>
    });

    return (
        <select key={guide.id} id={guide.id} onChange={onPublicationSelected}>
            <option value="" key="none"></option>
            {options}
        </select>
    );
}

function Guides({ guides }) {
    const guideList = Object.entries(guides).sort(([idA], [idB]) => parseInt(idA) - parseInt(idB)).map(([id, guide]) => {
        return (
            <div>
                <h4 key={guide.id}>{guide.guideType}: <Select guide={guide} /></h4>
            </div>
        );
    });

    return (
        guideList
    );
}

export default function Research() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get(file_path('/research.json')).then((res) => {
            setGuides(res.data);
        });
    }, []);

    return (
        <div className="container">
            <title>Research - L C Mills Consulting</title>
            <div className="body1">
                <h2>Research Schedule</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
